export function shareThis({ dataNetwork, dataUrl, dataTitle } = {}) {
  let shareThis = typeof window !== "undefined" && window.__sharethis__;
  if (shareThis) {
    shareThis.share({
      network: dataNetwork,
      url: dataUrl,
      title: dataTitle,
    });
  }
}

export function getUrl() {
  return typeof window !== "undefined" && window.location.href;
}